module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ops-support/settings/bulk-settings.component.less
// module id = 1041
// module chunks = 0